import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { Button } from '../../components/ui/Button';
import supabase from '../../supabase/supabase';

export default function Verified() {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    const handleVerification = async () => {
      try {
        const rawSearch = location.search || window.location.search;
        const hashAfterRoute = window.location.hash.split('?')[1] || '';
        const paramString = rawSearch ? rawSearch.slice(1) : hashAfterRoute;
        const params = new URLSearchParams(paramString);
        const accessToken = params.get('access_token');
        const refreshToken = params.get('refresh_token');

        let session = null;
        if (accessToken) {
          const { data, error } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken || accessToken,
          });
          session = data?.session;
        } else {
          await new Promise(res => setTimeout(res, 1000));
          const { data: sessionData } = await supabase.auth.getSession();
          session = sessionData?.session;
        }

        if (session?.user) {
          setStatus('redirecting');
          const { data: profile } = await supabase
            .from('profiles_1740423033529')
            .select('role, onboarding_completed')
            .eq('id', session.user.id)
            .single();

          // NOTE: Welcome email logic removed from here to prevent duplication.
          // It is now handled strictly in CustomerOnboarding and BarberOnboarding flows.

          setTimeout(() => {
            if (profile?.role === 'admin') navigate('/admin/dashboard');
            else if (profile?.role === 'barber') {
              navigate(profile.onboarding_completed ? '/barber/dashboard' : '/barber/onboarding');
            } else {
              navigate(profile.onboarding_completed ? '/app' : '/app/onboarding');
            }
          }, 1500);
        } else {
          setStatus('fallback');
        }
      } catch (err) {
        console.error('Verification error:', err);
        setStatus('fallback');
      }
    };
    handleVerification();
  }, [navigate, location]);

  if (status === 'checking') {
    return (
      <div className="min-h-screen bg-brand-light flex items-center justify-center p-6">
        <div className="text-center animate-in fade-in">
          <div className="w-16 h-16 border-4 border-brand-primary border-t-transparent rounded-full animate-spin mx-auto mb-6" />
          <p className="text-gray-500 font-black uppercase text-[10px] tracking-widest">Verifying your account...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-brand-light flex flex-col items-center justify-center p-6 text-center">
      <div className="bg-white p-10 rounded-[2.5rem] shadow-xl border border-gray-100 max-w-md w-full">
        <div className="w-20 h-20 bg-green-50 text-green-600 rounded-full flex items-center justify-center mb-6 mx-auto">
          <SafeIcon name="Check" className="text-4xl" />
        </div>
        <h1 className="text-2xl font-black text-brand-dark mb-2">Account Verified!</h1>
        <p className="text-gray-500 mb-8 font-medium">Redirecting you to the BookOTG platform...</p>
        <Button onClick={() => navigate('/login')} className="w-full py-4 font-black rounded-2xl">Sign In to Continue</Button>
      </div>
    </div>
  );
}